<template>
    <v-card :class="['service_box', backgroundColorClass, { 'active-card': isActive }]" link elevation="0"
        @click="cardClicked">
        <div class="service_box_contents">
            <div :class="['icon_box', iconBoxColorClass]">
                <v-icon large :class="'mdi mdi-video-outline icon' + (iconColor === 'blue' ? ' blue' : '')" />
            </div>
            <div class="service_box_txt">
                <h3 class="title">{{ title }}</h3>
                <p class="txt">{{ txt }}</p>
            </div>
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'CustomCard',
    props: {
        title: {
            type: String,
            default: 'title'
        },
        txt: {
            type: String,
            default: '설명입니다.'
        },
        iconColor: {
            type: String,
            default: 'blue'
        },
        iconBoxColor: {
            type: String,
            default: 'blue'
        },
        backgroundColor: {
            type: String,
            default: 'blue'
        },
        icon: {
            type: String,
            default: 'mdi-video-outline'
        },
        value: Number,
        isActive: Boolean,
    },
    computed: {
        backgroundColorClass() {
            return 'boxbg-' + this.backgroundColor;
        },
        iconBoxColorClass() {
            return 'iconboxbg-' + this.backgroundColor;
        },
    },
    methods: {
        cardClicked() {
            this.$emit('select', this.value);
        }
    }
};
</script>

<style scoped>

.active-card {
  border: 1px solid #bbb; 
}

.service_box {
    text-align: center;
    padding: 20px;
}

.service_box .service_box_contents {
    display: flex;
    height: 100%;
    text-align: left;
}

.service_box .service_box_txt p {
    margin-bottom: 0px;
    font-size: 14px;
    color: #888;
}

.service_box .icon_box {
    width: 70px;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin-right: 20px;
}

/* 아이콘 박스 컬러 */
.iconboxbg-blue {
    background: #8fc3fa;
}

.iconboxbg-pink {
    background: #ffe7fb;
}

.iconboxbg-green {
    background: #ddf4d6;
}

/* 백그라운드 컬러 클래스 */
.boxbg-blue {
    background-color: #f5f9ff;
}

.boxbg-green {
    background-color: #f6fff3;
}

.boxbg-yellow {
    background-color: #fff9cb;
}

/* 아이콘 컬러 */
.service_box .icon.blue {
    color: #3978bb;
}

.service_box .icon.green {
    color: #82d57e;
}
</style>